import React, { useState, useEffect } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import { useHistory } from 'react-router-dom'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import { useDispatch, useSelector } from 'react-redux'
import TierLimitHolder from '../../../Common-Objects/UI/Cards/TierLimitHolder'
import { updateTier } from '../../../data/actions/accountActions'
import useTierAllowed from '~/Common-Objects/hooks/useTierAllowed'

export default function InboxPage({ ...props }) {
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const account = useSelector((state) => state.accountMaster)
    const dispatch = useDispatch()
    const { requiredTier, tierAllowed } = useTierAllowed('inboxes')

    const init = async () => {
        const tier = await axios.get('/accountMaster/tier')
        if (!tierAllowed) return setLoading(false)
        dispatch(updateTier(tier.data.Tier))
        let inboxes = await axios.get('/inboxes')
        inboxes = inboxes.data
        if (inboxes.length > 0) {
            return history.push('/cp/conversations/inbox/' + inboxes[0].id)
        }
        setLoading(false)
    }

    const createInbox = async () => {
        let { data } = await axios.post('/inboxes', {
            name: 'Support'
        })
        history.push('/cp/conversations/inbox/' + data.id)
    }

    useEffect(() => {
        init()
    }, [tierAllowed])

    if (loading) return <LoadingIcons iconType='2' />

    return (
        <Paper style={{ paddingBottom: 0 }}>
            <Row className='mar-b25'>
                <Column xs={12} sm={6}>
                    <h2>{i18n.t('chat:landing.mainheader')}</h2>
                </Column>
                <Column xs={12} sm={6} style={{ textAlign: 'right' }}>
                    {tierAllowed && (
                        <Button
                            text='Create  Inbox'
                            iconLeft={<Icons icon='plus' />}
                            onClick={createInbox}
                        />
                    )}
                    {!tierAllowed && (
                        <Button
                            className='button-lightGrey'
                            text={i18n.t('chat:landing.help')}
                            onClick={() =>
                                window.open(
                                    'https://transpond.io/support/growing-your-audience/converstations',
                                    '_blank'
                                )
                            }
                            iconRight={<Icons icon='external' />}
                        />
                    )}
                </Column>
            </Row>

            <Row style={{ marginBottom: 50 }}>
                <Column
                    xs={12}
                    lg={10}
                    className='col-lg-offset-1'
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <h2 className='mar-b15'>{i18n.t('chat:landing.subheader')}</h2>
                    <div className='mar-b25'>{i18n.t('chat:landing.desc')}</div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {tierAllowed && (
                            <Button
                                text={i18n.t('chat:landing.create')}
                                iconLeft={<Icons icon='plus' />}
                                onClick={createInbox}
                                className='mar-r10 button-primary'
                            />
                        )}
                        {!tierAllowed && (
                            <TierLimitHolder
                                err='tierForbids'
                                upsell={requiredTier}
                                feature='inboxes'
                                tierName={account.tier.name}
                                type='Conversations'
                                newLayout={true}
                                noMarg={true}
                                description='Unify live chat and email to respond to enquiries better and faster. And convert leads into loyal customers.'
                            />
                        )}
                        {tierAllowed && (
                            <Button
                                className='button-lightGrey'
                                text={i18n.t('chat:landing.help')}
                                onClick={() =>
                                    window.open(
                                        'https://transpond.io/support/growing-your-audience/converstations',
                                        '_blank'
                                    )
                                }
                                iconRight={<Icons icon='external' />}
                            />
                        )}
                    </div>
                </Column>
            </Row>
            <div style={{ textAlign: 'center' }}>
                <img
                    src='https://cdn1.ourmailsender.com/siteContent/conversations/attract/conversationsAttract.png'
                    style={{ width: '100%', maxWidth: '1000px' }}
                ></img>
            </div>
        </Paper>
    )
}
